import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=0b9e83d0&scoped=true&"
import script from "./Affiliation.vue?vue&type=script&lang=js&"
export * from "./Affiliation.vue?vue&type=script&lang=js&"
import style0 from "./Affiliation.vue?vue&type=style&index=0&id=0b9e83d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e83d0",
  null
  
)

export default component.exports